import React from 'react';
import { QuestionTemplate } from '@Models/QuestionTemplate';
import { Metric } from '@Models/Metric';
import { Article } from '@jcharlesworthuk/your-mum-frontend/models';

type State = {
    latestArticles: Article[]
};

const emptyState: State = {
    latestArticles: []
}

type ContextType = State;

export const BlogArticlesContext = React.createContext<ContextType>({
    ...emptyState
});

export function BlogArticlesContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    return <BlogArticlesContext.Provider value={props.initialState || emptyState}>{props.children}</BlogArticlesContext.Provider>;
}
